var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { position: "relative" } },
    [
      _vm.ductEntryType !== undefined
        ? _c(
            "v-layout",
            {
              directives: [
                {
                  name: "on-clickaway",
                  rawName: "v-on-clickaway",
                  value: _vm.hideContextMenu,
                  expression: "hideContextMenu"
                }
              ],
              staticClass: "shape-container",
              class: { selected: _vm.isSelected },
              style: _vm.shapeContainerSize,
              attrs: { row: "", "align-center": "", "justify-center": "" },
              on: {
                click: _vm.toggleForm,
                contextmenu: function($event) {
                  return _vm.$emit("showContextMenu", $event)
                }
              }
            },
            [
              _c(
                "v-flex",
                [
                  _c(
                    "duct-entry-shape",
                    {
                      attrs: {
                        shape: _vm.ductEntryType.shape,
                        width: _vm.ductEntryType.width,
                        height: _vm.ductEntryType.height,
                        state: _vm.ductEntryState
                      }
                    },
                    [
                      _c(
                        "v-layout",
                        {
                          attrs: {
                            row: "",
                            "align-center": "",
                            "justify-center": "",
                            "fill-height": ""
                          }
                        },
                        [
                          _c(
                            "v-flex",
                            {
                              staticClass: "font-weight-bold",
                              style: _vm.labelSize
                            },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(_vm.ductEntry.mde_label) +
                                  "\n          "
                              )
                            ]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-03272cfc", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-03272cfc","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home/Forms/_SpecialTabs/Masks/Duct/GridDuctEntry.vue
// module id = null
// module chunks = 